import { render, staticRenderFns } from "./caseRepoLink.vue?vue&type=template&id=543ade51"
import script from "./caseRepoLink.vue?vue&type=script&lang=js"
export * from "./caseRepoLink.vue?vue&type=script&lang=js"
import style0 from "./caseRepoLink.vue?vue&type=style&index=0&id=543ade51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports